<form [formGroup]="form">
  <h3>{{'Project (Licence)' | translate}}</h3>
  <mat-form-field class="w-full">
    <mat-label>VRS</mat-label>
    <input matInput placeholder="" formControlName="vrs" [value]="initialLicence?.vrs"/>

    <button mat-icon-button class="undoButton" *ngIf="form.get('vrs')?.dirty && form.get('vrs')?.value != ''; else generateVrs" (click)="undoChanges('vrs',''); $event.stopPropagation()">
      <mat-icon>undo</mat-icon>
    </button>
    <ng-template #generateVrs>
      <button mat-icon-button color="primary" class="undoButton" (click)="generateVrsNumber()" title="Generate VRS"><mat-icon>
        <span class="material-symbols-outlined">
          wand_stars
        </span>
      </mat-icon></button>
    </ng-template>
  <mat-error *ngIf="form.get('vrs')?.invalid">
  {{"dialog.vrsError" | translate}}
  </mat-error>
  </mat-form-field>
  <mat-form-field class="w-full">
    <mat-label>{{"dialog.projectName" | translate}}</mat-label>
    <input matInput placeholder="" formControlName="projectName" [value]="initialLicence?.project"/>
    <button mat-icon-button class="undoButton" *ngIf="form.get('projectName')?.dirty && form.get('projectName')?.value != ''" (click)="undoChanges('projectName',''); $event.stopPropagation()">
      <mat-icon>undo</mat-icon>
    </button>
    @if(form.get('projectName')?.invalid) {
    <mat-error>{{"dialog.projectError" | translate}}</mat-error>
    }
  </mat-form-field>
  <mat-form-field class="w-full">
    <mat-label>{{"dialog.type" | translate}}</mat-label>
    <mat-select formControlName="type" [value]="initialLicence?.licence_type_id">
      @for (type of licenceTypes; track $index) {
      <mat-option [value]="type.id">{{ type.name }}</mat-option>
      }
    </mat-select>
    <button mat-icon-button class="undoButton" *ngIf="form.get('type')?.dirty && form.get('type')?.value != ''" (click)="undoChanges('type',''); $event.stopPropagation()">
      <mat-icon>undo</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field class="w-full">
    <mat-label>{{"dialog.status" | translate}}</mat-label>
    <mat-select formControlName="status" [value]="initialLicence?.licence_status_id">
      @for (status of licenceStatuses; track $index) {
      <mat-option [value]="status.id">
        {{ status.status }}
      </mat-option>
      }
    </mat-select>
    <button mat-icon-button class="undoButton" *ngIf="form.get('status')?.dirty && form.get('status')?.value != ''" (click)="undoChanges('status',''); $event.stopPropagation()">
      <mat-icon>undo</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field style="width: calc(50% - .5rem); margin-right: 1rem;">
      <mat-label>{{"dialog.opex" | translate}}</mat-label>
      <mat-select formControlName="opex" [value]="initialLicence?.opex">
        <mat-option [value]="true">
          OPEX
        </mat-option>
        <mat-option [value]="false">
          CAPEX
        </mat-option>
      </mat-select>
      <button mat-icon-button class="undoButton" *ngIf="form.get('opex')?.dirty && form.get('opex')?.value != ''" (click)="undoChanges('opex',''); $event.stopPropagation()">
        <mat-icon>undo</mat-icon>
      </button>
  </mat-form-field>
  <mat-form-field style="width: calc(50% - .5rem)">
    <mat-label>Offline</mat-label>

    <mat-select [disabled]="form.get('opex')?.value == true" formControlName="offline" [value]="initialLicence?.offline">
        <mat-option [value]="true">
          Offline
        </mat-option>
        <mat-option [value]="false">
          Online
        </mat-option>
      </mat-select>
      <button mat-icon-button class="undoButton" *ngIf="form.get('offline')?.dirty && form.get('offline')?.value != ''" (click)="undoChanges('offline',''); $event.stopPropagation()">
        <mat-icon>undo</mat-icon>
      </button>
  </mat-form-field>
</form>
<div *ngIf="isSuspended" class="isSuspended">
  <mat-icon>warning</mat-icon>
  <p> {{"dialog.IsSuspendedInfo" | translate}} </p>
</div>

<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=wand_stars" />
